export enum LoginBarDataHooks {
  ROOT = 'login-bar',
  TEXT = 'login-bar-text',
  LOGIN_BUTTON = 'login-bar-login-button',
  LOGOUT_BUTTON = 'login-bar-logout-button',
}
